import { render, staticRenderFns } from "./latestPredictionsEdit.vue?vue&type=template&id=6c16017f&"
import script from "./latestPredictionsEdit.vue?vue&type=script&lang=js&"
export * from "./latestPredictionsEdit.vue?vue&type=script&lang=js&"
import style0 from "./latestPredictionsEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports